export const SHOW_MODES = {
  TABLE: 'table',
  GRID: 'grid',
};
